import { useStore } from 'ra-core';
/**
 * Read and update the theme mode (light or dark)
 *
 * @example
 * const [theme, setTheme] = useTheme('light');
 * const toggleTheme = () => {
 *    setTheme(theme === 'light' ? 'dark' : 'light');
 * };
 *
 * @example // legacy mode, stores the full theme object
 * // to be removed in v5
 * const [theme, setTheme] = useTheme({
 *    palette: {
 *       type: 'light',
 *   },
 * });
 */
export var useTheme = function (type) {
    // FIXME: remove legacy mode in v5, and remove the RaThemeOptions type
    var _a = useStore('theme', type), theme = _a[0], setter = _a[1];
    return [theme, setter];
};
//# sourceMappingURL=useTheme.js.map